import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, FormField, SelectProps, NonCancelableCustomEvent } from '@amzn/awsui-components-react';
import { SmartEOptions } from '../../constants';
import { FormSchema } from 'modules/mappings/models';
import style from './ChannelTypeSmartE.module.scss';

interface ChannelTypeSmartEProps {
    defaultSelection?: string;
    channelType: string;
    onChange?: (id: string) => void;
}

export const ChannelTypeSmartE = (props: ChannelTypeSmartEProps) => {
    const { onChange, defaultSelection, channelType } = props;

    const { t } = useTranslation('mappings');

    const { register, setValue, triggerValidation, errors } = FormSchema.getSMARTeUseForm();

    const optionsList: SelectProps.Option[] = Object.values(SmartEOptions).map(value => ({
        value: `${channelType}$${value}`,
        label: t(`smartEMappings.dropdown.smartEList.${value}`)
    }));

    const [selection, updateSelection] = useState(
        optionsList.find(option => option.value?.split('$')[1] === defaultSelection)
    );

    useEffect(() => {
        register({ name: 'smartE', type: 'custom' });
    }, [register]);

    const setSmartEValue = (smartEValue: string) => {
        setValue('smartE', smartEValue, true);
    };

    const onSmartEChange = ({ detail }: NonCancelableCustomEvent<SelectProps.ChangeDetail>) => {
        const { selectedOption } = detail;

        setSmartEValue(selectedOption.label ?? '');
        triggerValidation('smartE');

        if (onChange) {
            const { value } = selectedOption;
            onChange(value ?? '');
        }
        updateSelection(selectedOption);
    };

    return (
        <div className={style['awsui-select-dropdown']}>
            <FormField label={t(`dropdown.channelsList.${channelType}`)} errorText={errors?.smartE?.message}>
                <Select
                    selectedOption={selection as SelectProps.Option}
                    options={optionsList}
                    data-cy="SmartEListDropDown"
                    placeholder={t('smartEMappings.dropdown.placeholderSelect')}
                    onChange={onSmartEChange}
                />
            </FormField>
        </div>
    );
};
